import React from 'react';

const TajThankYouMessage = () => {
  return (
    <div style={{ 
      textAlign: 'center', 
      paddingTop: '20px', 
      paddingBottom: '20px' 
    }}>
      <h2 style={{
        color: '#8b6914',
        fontFamily: "'Georgia', serif",
        fontSize: '24px',
        marginBottom: '10px',
        fontWeight: '700'
      }}>
        Thank You for Choosing Taj
      </h2>
      
      <div 
        className="taj-animated-line" 
        style={{
          width: '100%',
          height: '3px',
          background: 'linear-gradient(to right, #e9c174, #f4d78f, #e9c174)',
          margin: '10px auto 20px',
          borderRadius: '2px',
          transform: 'scaleX(0)',
          animation: 'expandFullLine 2s ease-out 0.5s forwards'
        }}
      />
      
      <p style={{
        color: '#8b6914',
        fontSize: '16px',
        lineHeight: '1.6',
        margin: '0'
      }}>
        Your request has been received with the utmost care.<br/>
        Our dedicated team will attend to your needs promptly.<br/>
        <em style={{ 
          fontStyle: 'italic', 
          color: '#a68a64' 
        }}>
          Experience the royal hospitality that defines Taj.
        </em>
      </p>
    </div>
  );
};

export default TajThankYouMessage;